var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9949 5.49999C20.5166 5.22385 19.905 5.38772 19.6289 5.86602L13.9493 15.7034C13.8173 15.9321 13.7318 16.1846 13.6979 16.4465L13.2998 19.5199C13.2772 19.695 13.362 19.8666 13.5149 19.9549C13.6678 20.0431 13.8588 20.0308 13.9991 19.9236L16.4617 18.0422C16.6716 17.8819 16.8476 17.6816 16.9796 17.4529L21.1834 10.1718L18.1533 8.42234L18.9033 7.1233L21.9334 8.87271L22.6592 7.61556C22.9353 7.13726 22.7715 6.52567 22.2932 6.24953L20.9949 5.49999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C4.89543 12 4 12.8954 4 14C4 18.4183 7.58172 22 12 22C15.9239 22 19.188 19.1749 19.8693 15.4478L18.2786 18.2029C18.0476 18.6031 17.7396 18.9536 17.3724 19.2341L14.9098 21.1156C14.2883 21.5904 13.4423 21.645 12.7649 21.2539C12.0876 20.8628 11.7118 20.1029 11.8123 19.3272L12.2104 16.2538C12.2697 15.7955 12.4192 15.3536 12.6503 14.9534L14.3554 12H6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.aac4db9fe4d8bad62ab9d086c304e5c5.svg";
export { ForwardRef as ReactComponent };